"use client"

import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import { ComponentConfig } from "@measured/puck"
import Image from "next/image"
import { useState } from "react"
import "swiper/css"
import "swiper/css/pagination"
import { Autoplay } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import IconQuote from "../../../../../../../../public/images/icon-Quote.png"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"
import "./CustomFeedback.css"
export interface FeedbackItem {
  textField: {
    title?: string
    titleFontSize?: string
    titleFontWeight?: string
    titleLineHeight?: string
    content?: string
    contentTextSize?: string
    contentTextWeight?: string
    contentLineHeight?: string
  }
  textContainerStyles?: {
    position?: "top-left" | "top-right" | "bottom-left" | "bottom-right" | "center"
    color?: string
    padding?: string
    gap?: string
  }
  customerStyles?: {
    avatar?: string
    name?: string
    nameFontSize?: string
    nameFontWeight?: string
    nameLineHeight?: string
    location?: string
    locationFontSize?: string
    locationFontWeight?: string
    locationLineHeight?: string
    widthAvatar?: string
    heightAvatar?: string
    margin?: string
  }
}

export interface FeedbackProps extends CommonStylesProps {
  heightFeedback?: string
  gapFeedback?: string
  feedbackItems?: FeedbackItem[]
  type: "fluid" | "custom" | "boxed"
}

export const RenderConfig: ComponentConfig<FeedbackProps> = {
  render: ({ className, type, styles, responsiveType, heightFeedback, gapFeedback, feedbackItems = [] }) => {
    const id = `navigation-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)
    const [currentIndex, setCurrentIndex] = useState(0)

    const gapValue = gapFeedback ? parseInt(gapFeedback.replace("px", "")) || 24 : 24

    return (
      <>
        {responsiveCSS}
        <div id={id} className="relative w-full overflow-hidden">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={gapValue}
            slidesPerView="auto"
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            onSlideChange={swiper => setCurrentIndex(swiper.realIndex)}
            breakpoints={{
              0: {
                // slidesPerView: 1,
                spaceBetween: gapValue,
              },
              1024: {
                // slidesPerView: 3.2,
                spaceBetween: gapValue,
              },
            }}
            className="!overflow-visible"
          >
            {feedbackItems.map((item, index) => (
              <SwiperSlide key={index} className="!w-auto">
                <div className="p-6 border border-[#F5F5F5] rounded-lg lg:max-w-[454px] max-w-[343px] w-full bg-[#F2F2F780] flex flex-col items-start relative h-full">
                  <Image
                    src={IconQuote.src}
                    alt="Feedback Icon"
                    className="mb-6 w-[28.8px] h-6"
                    width={28.8}
                    height={6}
                  />
                  <div className="flex flex-col h-full">
                    <div className="flex flex-col gap-2">
                      <h3
                        style={{
                          color: item.textContainerStyles?.color,
                          fontSize: item.textField?.titleFontSize,
                          fontWeight: item.textField?.titleFontWeight,
                          lineHeight: item.textField?.titleLineHeight,
                        }}
                      >
                        {item.textField?.title}
                      </h3>
                      <p className="lg:w-full w-[295px] text-base text-[#242F3E]">{item.textField?.content}</p>
                    </div>
                    <div className="flex items-center gap-2 mt-6">
                      <Image
                        src={`${ADMIN_API_CONFIG.API_URL}${item.customerStyles?.avatar}`}
                        alt="Avatar"
                        className="rounded-full"
                        style={{
                          width: item.customerStyles?.widthAvatar || "40px",
                          height: item.customerStyles?.heightAvatar || "40px",
                          margin: item.customerStyles?.margin || "0",
                        }}
                        width={40}
                        height={40}
                      />
                      <div className="flex flex-col gap-1">
                        <p
                          style={{
                            fontSize: item.customerStyles?.nameFontSize || "16px",
                            fontWeight: item.customerStyles?.nameFontWeight || 700,
                            lineHeight: item.customerStyles?.nameLineHeight || "19px",
                          }}
                        >
                          {item.customerStyles?.name}
                        </p>
                        <p
                          style={{
                            fontSize: item.customerStyles?.locationFontSize || "14px",
                            fontWeight: item.customerStyles?.locationFontWeight || 400,
                            lineHeight: item.customerStyles?.locationLineHeight || "16px",
                          }}
                        >
                          {item.customerStyles?.location}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="flex items-center w-full justify-center lg:hidden">
          <div className="flex justify-center mt-4 bg-[#242F3E0F] py-[10px] px-2 rounded-full">
            {feedbackItems.map((_, index) => (
              <div
                key={index}
                className={`h-2 w-2 mx-[5px] rounded-full transition-all ${
                  currentIndex === index ? "bg-[#000] w-6" : "bg-[#D9D9D9]"
                }`}
              />
            ))}
          </div>
        </div>
      </>
    )
  },
}
